module.exports = __webpack_public_path__ + "img/Gefahr_durch_gefährliche_Stoffe.1b91bf50.svg";